"use client";
import styled from "../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import Icon from "../../../components/atoms/Icon/index.js";
const ROTATE_HALF = 180;
export const RotatingIconAtomComponent = styled(Icon, {
    name: "SdbRotatingIcon",
    slot: "Root",
    shouldForwardProp: shouldForwardProp("direction", "translateDown", "translateUp", "disabled", "degrees"),
})(({ theme, direction, translateDown, translateUp, disabled, color, degrees = ROTATE_HALF }) => ({
    transition: theme.transitions.create(["transform", "translate"], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeIn,
    }),
    translate: translateDown || translateUp ? `0 ${direction === "desc" ? translateDown : translateUp}` : "",
    transform: `rotate(${direction === "asc" ? 0 : degrees}deg)`,
    color: disabled ? "green" : (color ?? theme.vars.palette.primary.main),
}));
export default RotatingIconAtomComponent;
